document.addEventListener("turbolinks:load", function() {
  $("body").on('click', '.toggle-password', function() {
    $(this).toggleClass("fe-eye fe-eye-off");
    var input = $("#user_password");
    if (input.attr("type") === "password") {
      input.attr("type", "text");
    } else {
      input.attr("type", "password");
    }
  });

  $("body").on('click', '.toggle-password-confirmation', function() {
    $(this).toggleClass("fe-eye fe-eye-off");
    var input = $("#user_password_confirmation");
    if (input.attr("type") === "password") {
      input.attr("type", "text");
    } else {
      input.attr("type", "password");
    }
  });

  $("#signin_form").validate({
    validClass: "valid-feedback",
    errorClass: "invalid-feedback",
    highlight: function (element) {
      $(element).addClass("is-invalid").removeClass("is-valid");
    },
    unhighlight: function (element) {
      $(element).removeClass("is-invalid").addClass("is-valid");
    },
    rules: {
      "user[email]": {
        required: true,
        email: true
      },
      "user[password]": {
        required: true
      },
    },
    errorPlacement: function (error, element) {
      if (element.attr("name") == "user[password]") {
        error.insertAfter(".input-group-merge");
      } else {
        error.insertAfter(element);
      }
    }
  });

  $("#signup_form").validate({
    validClass: "valid-feedback",
    errorClass: "invalid-feedback",
    highlight: function(element) {
      $(element).addClass("is-invalid").removeClass("is-valid");
    },
    unhighlight: function(element) {
      $(element).removeClass("is-invalid").addClass("is-valid");
    },
    rules: {
      "user[email]": {
        required: true,
        email: true
      },
      "user[password]": {
        required: true,
        minlength:6
      },
      "user[first_name]": {
        required: true
      },
      "user[last_name]": {
        required: true
      },
      "user[company_role]": {
        required: true
      },

    },
    errorPlacement: function(error, element) {
      if (element.attr("name") == "user[password]") {
        error.insertAfter(".input-group-merge");
      } else {
        error.insertAfter(element);
      }
    }
  });

  $("#organization_form").validate({
    validClass: "valid-feedback",
    errorClass: "invalid-feedback",
    highlight: function (element) {
      $(element).addClass("is-invalid").removeClass("is-valid");
    },
    unhighlight: function (element) {
      $(element).removeClass("is-invalid").addClass("is-valid");
    },
    rules: {
      "organization[name]": {
        required: true
      },
      "organization[monthly_cloud_spend]": {
        required: true
      },
    },
    errorPlacement: function (error, element) {
      error.insertAfter(element);
    }
  });

  $("#account_form").validate({
    validClass: "valid-feedback",
    errorClass: "invalid-feedback",
    highlight: function (element) {
      $(element).addClass("is-invalid").removeClass("is-valid");
    },
    unhighlight: function (element) {
      $(element).removeClass("is-invalid").addClass("is-valid");
    },
    rules: {
      "account[name]": {
        required: true
      },
      "account[aws_account_id]": {
        required: true
      },
    }
  });

  $("#onboarding_account_form").validate({
    validClass: "valid-feedback",
    errorClass: "invalid-feedback",
    highlight: function(element) {
      $(element).addClass("is-invalid").removeClass("is-valid");
    },
    unhighlight: function(element) {
      $(element).removeClass("is-invalid").addClass("is-valid");
    },
    ignore: [],
    rules: {
      "account[name]": {
        required: true
      },
      "account[aws_account_id]": {
        required: true
      },
    }
  });

  $("#freeze_form").validate({
    validClass: "valid-feedback",
    errorClass: "invalid-feedback",
    highlight: function (element) {
      $(element).addClass("is-invalid").removeClass("is-valid");
    },
    unhighlight: function (element) {
      $(element).removeClass("is-invalid").addClass("is-valid");
    },
    rules: {
      "freeze[name]": {
        required: true
      },
      "freeze[start_at]": {
        required: true
      },
      "freeze[finish_at]": {
        required: true
      },
    }
  });

  $("#maintenance_window_form").validate({
    validClass: "valid-feedback",
    errorClass: "invalid-feedback",
    highlight: function (element) {
      $(element).addClass("is-invalid").removeClass("is-valid");
    },
    unhighlight: function (element) {
      $(element).removeClass("is-invalid").addClass("is-valid");
    },
    rules: {
      "maintenance_window[name]": {
        required: true
      },
      "maintenance_window[start_at]": {
        required: true
      },
      "maintenance_window[duration]": {
        required: true
      },
      "maintenance_window[days_of_week]": {
        required: true
      },
    }
  });

  $("#peak_hour_form").validate({
    validClass: "valid-feedback",
    errorClass: "invalid-feedback",
    highlight: function (element) {
      $(element).addClass("is-invalid").removeClass("is-valid");
    },
    unhighlight: function (element) {
      $(element).removeClass("is-invalid").addClass("is-valid");
    },
    rules: {
      "peak_hour[name]": {
        required: true
      },
      "peak_hour[start_at]": {
        required: true
      },
      "peak_hour[duration]": {
        required: true
      },
      "peak_hour[days_of_week]": {
        required: true
      },
    },
    errorPlacement: function (error, element) {
      if (element.attr("name") == "user[password]") {
        error.insertAfter(".input-group-merge");
      } else {
        error.insertAfter(element);
      }
    }
  });

  $("#tag_form").validate({
    validClass: "valid-feedback",
    errorClass: "invalid-feedback",
    highlight: function (element) {
      $(element).addClass("is-invalid").removeClass("is-valid");
    },
    unhighlight: function (element) {
      $(element).removeClass("is-invalid").addClass("is-valid");
    },
    rules: {
      "tag[name]": {
        required: true
      },
      "tag[kind]": {
        required: true
      },
      "tag[value]": {
        required: true
      },
    }
  });
})
